export default "__VITE_ASSET__CStcK2BW__"